module.exports = __webpack_public_path__ + "media/images/flags/32/Singapore-67fcc988f725a030fbee9080587247ba.png";